import { Box, Flex, Heading, Text } from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router-dom'
import type { ReactNode } from 'react'

type Props = {
  title: string
  children: ReactNode
  actionLabel?: string
  actionTo?: string
  mb?: number | string
}

export default function DashboardSection({
  title,
  children,
  actionLabel,
  actionTo,
  mb = 0,
}: Props) {
  return (
    <Box w="100%" minW={0} mb={mb} flexShrink={0}>
      <Flex justify="space-between" align="center" mb={2} gap={2} flexWrap="wrap">
        <Heading size="xs" color="gray.600" m={0} textTransform="uppercase" letterSpacing="0.04em">
          {title}
        </Heading>
        {actionLabel && actionTo ? (
          <Text
            as={RouterLink}
            to={actionTo}
            fontSize="sm"
            color="blue.600"
            _hover={{ textDecoration: 'underline' }}
            whiteSpace="nowrap"
          >
            {actionLabel}
          </Text>
        ) : null}
      </Flex>
      {children}
    </Box>
  )
}
